import styled from 'styled-components';
import color from 'tinycolor2';

export const ProjectColumnText = styled.div`
  font-size: 14px;
  line-height: 19px;
`;

export const ColoredText = styled.span`
  color: ${(props) => props.color || 'rgba(0,0,0,0.4)'};
  ${(props) => props.workspaceRedesign && `
    position: relative;
    height: 40px;
    width: 40px;
    background: ${props.theme['themeId'] === 'dark'
    ? color(props.theme['color.purpleLight']).setAlpha(0.3).toString()
    : color(props.theme['color.purpleLight']).setAlpha(0.1).toString()};
    border-radius: 4px;
    
    & svg {
      position: absolute;
      color: ${props.theme['color.purpleLight']};
      top: 9px;
      left: 8px;
    }`}
`;

export const ActivityName = styled.span`
  margin-left: 15px;
`;

export const CourseType = styled.p`
  font-weight: 200;
  font-size: 14px;
  margin-left: 4px;
  margin-top: 4px;
  margin-bottom: 0px;
`;


export const CourseInfoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
